import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creativetabletemplate',
  templateUrl: './creativetabletemplate.component.html',
  styleUrls: ['./creativetabletemplate.component.css']
})
export class CreativetabletemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
